export const cacheConstant = {
	userData: "USER_DATA",
	configurationSettings: "CONFIGURATION_SETTINGS",
	companyUserList: "COMPANY_USER_LIST",
	userCompany: "USER_COMPANY",
	pdfUrl: "PDF_URL"
};

type cacheKeys = keyof typeof cacheConstant;

class AppCache {
	constructor() {
		this.updateCacheFromLocalStorage();
		localStorage.removeItem("token");
	}
	data: Partial<Record<cacheKeys, any>> = {};
	private memoryStore: Map<string, any> = new Map();
	private sensitiveKeys = new Set(["token"]);

	private updateCacheFromLocalStorage = () => {
		this.data = Object.keys(cacheConstant).reduce((total, key) => {
			const currKey = key as cacheKeys;
			const cacheDataString = localStorage.getItem(
				cacheConstant[currKey]
			);
			if (!!!cacheDataString) {
				return total;
			}
			let cacheData = null;
			try {
				cacheData =
					(!!cacheDataString && JSON.parse(cacheDataString)) || null;
			} catch (error) {
				console.error(error);
			}
			total[currKey] = cacheData;
			return total;
		}, {} as any);
	};

	updateReduxKey = (key: cacheKeys, data: any | null) => {
		if (!data) {
			localStorage.removeItem(cacheConstant[key]);
		}
		const stringifiedData = JSON.stringify(data);

		if (!stringifiedData?.length) {
			localStorage.removeItem(cacheConstant[key]);
		}

		localStorage.setItem(cacheConstant[key], stringifiedData);
		this.updateCacheFromLocalStorage();
	};

	get = (key: string, parseJson = false): any => {
		if (this.sensitiveKeys.has(key)) {
			return this.memoryStore.get(key) ?? null;
		}
		let data: any = localStorage.getItem(key) || null;
		if (data && parseJson) {
			try {
				data = JSON.parse(data);
			} catch (error) {
				console.error(
					`Error: ${error} :: key: ${key} :: data: ${data}`
				);
			}
		}
		return data;
	};
	save = (key: string, data: any) => {
		if (this.sensitiveKeys.has(key)) {
			this.memoryStore.set(key, JSON.parse(JSON.stringify(data)));
			return;
		}
		localStorage.setItem(key, JSON.stringify(data));
	};
	deleteItem = (key: string) => {
		this.memoryStore.delete(key);
		localStorage.removeItem(key);
	};
	deleteAll = () => {
		this.memoryStore.clear();
		localStorage.clear();
	};
}

export default new AppCache();
